module.exports = __webpack_public_path__ + "img/setting-icon.4e979521.png";